/**
 * @generated SignedSource<<0a3acbd8055a080237a2d90b154934ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cardFieldsList_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldsByIdOrAlias: ReadonlyArray<{
    readonly __typename: string;
    readonly fieldId: string;
    readonly id: string;
    readonly type: string;
    readonly " $fragmentSpreads": FragmentRefs<"colorField_updateWorkItemFieldsActionRenderer" | "datePickerField_updateWorkItemFieldsActionRenderer" | "dateTimePickerField_updateWorkItemFieldsActionRenderer" | "flagField_updateWorkItemFieldsActionRenderer" | "genericField_updateWorkItemFieldsActionRenderer" | "labelsField_updateWorkItemFieldsActionRenderer" | "numberField_updateWorkItemFieldsActionRenderer" | "parentIssueField_updateWorkItemFieldsActionRenderer" | "priorityField_updateWorkItemFieldsActionRenderer" | "richTextField_updateWorkItemFieldsActionRenderer" | "singleLineTextField_updateWorkItemFieldsActionRenderer" | "singleSelectUserPickerField_updateWorkItemFieldsActionRenderer" | "statusField_updateWorkItemFieldsActionRenderer" | "timeSpentField_updateWorkItemFieldsActionRenderer" | "timeTrackingField_updateWorkItemFieldsActionRenderer" | "usersField_updateWorkItemFieldsActionRenderer">;
  } | null> | null;
  readonly " $fragmentType": "cardFieldsList_updateWorkItemFieldsActionRenderer";
};
export type cardFieldsList_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: cardFieldsList_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"cardFieldsList_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fieldIdsOrAliases"
    }
  ],
  "kind": "Fragment",
  "name": "cardFieldsList_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "idsOrAliases",
          "variableName": "fieldIdsOrAliases"
        },
        {
          "kind": "Literal",
          "name": "ignoreMissingFields",
          "value": true
        }
      ],
      "kind": "LinkedField",
      "name": "fieldsByIdOrAlias",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "fieldId"
        },
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "FragmentSpread",
          "name": "singleLineTextField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "richTextField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "singleSelectUserPickerField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "usersField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "statusField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "priorityField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "labelsField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "flagField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "datePickerField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "dateTimePickerField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "parentIssueField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "numberField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "timeTrackingField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "timeSpentField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "colorField_updateWorkItemFieldsActionRenderer"
        },
        {
          "kind": "FragmentSpread",
          "name": "genericField_updateWorkItemFieldsActionRenderer"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "0f54e478bb681c45db2546d20f4b3f2e";

export default node;
